/*
  Converts standard base64 to URL-safe base64 (RFC 4648 [https://datatracker.ietf.org/doc/html/rfc4648#page-8]): "+" -> "-", "/" -> "_",
 */
export function toUrlSafeBase64(base64: string): string {
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/*
  Converts URL-safe base64 back to standard, padded base64 for atob().
 */
export function toStandardBase64(encoded: string): string {
  const base64 = encoded.replace(/-/g, "+").replace(/_/g, "/");
  return base64 + "=".repeat((4 - (base64.length % 4)) % 4);
}

export function bytesToBase64(bytes: Uint8Array): string {
  // `String.fromCharCode(...bytes)` in one call overflows the call stack past an
  // engine-dependent limit (a hard ~65k args in JSC; stack-depth dependent in V8).
  const chunkSize = 8192;
  let binary = "";
  for (let index = 0; index < bytes.length; index += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(index, index + chunkSize));
  }
  return btoa(binary);
}
